import {observer} from 'mobx-react';
import {Dispatch, SetStateAction, useEffect, useMemo} from 'react';
import {useStoreContext} from '../../../../../../../../store/store-context';
import {VerticalSpacer} from '../../../../../../../../ui/atoms/spacer';
import {Body2, Headline3} from '../../../../../../../../ui/atoms/typography';
import {PlansSection, Wrapper} from './billing-not-active.styles';
import {BillingPlans} from './components/billing-plans';
import {BillingSeats} from './components/billing-seats';

interface IAdminBillingNotActive {
  setShowStarterPlanCTA: Dispatch<SetStateAction<boolean>>;
}
export const AdminBillingNotActive = observer(
  ({setShowStarterPlanCTA}: IAdminBillingNotActive) => {
    const {
      billingsStore: {billingPlans, loader},
      billingRoutesStore: {InactiveBillingTabs, activateInactiveBillingTabs},
    } = useStoreContext();

    const billingCycle = 'monthly' as const;

    useEffect(() => {
      setShowStarterPlanCTA(true);
      return () => {
        setShowStarterPlanCTA(false);
      };
    }, [setShowStarterPlanCTA]);

    useEffect(() => {
      if (InactiveBillingTabs.billingCycle) {
        activateInactiveBillingTabs('plans');
      }
    }, [InactiveBillingTabs.billingCycle, activateInactiveBillingTabs]);

    const Plans = useMemo(() => {
      const billingplans_ = [
        {
          name: 'Standard',
          currency: billingPlans?.currency,
          monthly: {
            unitCost: billingPlans?.growth?.monthly?.unit_cost,
          },
          yearly: {
            unitCost: billingPlans?.growth?.yearly?.unit_cost,
            yearlyUnitCost: billingPlans?.growth?.yearly?.yearly_unit_cost,
            yearlyDiscountPercent:
              billingPlans?.growth?.yearly?.yearly_discount_percent,
          },
          isVisible: billingCycle === 'monthly',
          plan: 'growth',
          active: false,
        },
      ];

      return billingplans_;
    }, [
      billingPlans?.currency,
      billingPlans?.growth?.monthly?.unit_cost,
      billingPlans?.growth?.yearly?.unit_cost,
      billingPlans?.growth?.yearly?.yearly_discount_percent,
      billingPlans?.growth?.yearly?.yearly_unit_cost,
    ]);

    return (
      <Wrapper>
        {!InactiveBillingTabs.seats && (
          <PlansSection>
            <Headline3 kind="textDark" align="left">
              Review pricing
            </Headline3>
            <VerticalSpacer size="8px" />
            <Body2 kind="textBody" align="left">
              Compare monthly and annual billing before continuing.
            </Body2>

            <BillingPlans
              plans={Plans as any}
              billingCycle={billingCycle}
              loader={loader.billingPlans as boolean}
            />
          </PlansSection>
        )}
        {InactiveBillingTabs.seats && <BillingSeats />}
      </Wrapper>
    );
  },
);
